// Module
var code = "<!-- Input -->\n<cjs-input class=\"flex-container flex-item h-100\" ref=\"input\"></cjs-input>\n\n<!-- Items selector -->\n<cjs-smart-select ref=\"smartSelect\" class=\"position-absolute w-100 h-100\"></cjs-smart-select>";
// Exports
module.exports = code;